<!-- Footer Buttons -->
<tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
<tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>